'use client';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { IBARAKI_REGION_ROUTE } from '@/app/ibaraki-region/constants/region';
import { relativePath } from '@/functions/redirectToRelativePath';

/**
 * cityが選択済みの場合に表示するエリア選択コンポーネント
 */
type Props = {
  areaId: string | null;
  setAreaId: (categoryId: string | null) => void;
  cityDomain: string | null;
  customerSetting: IbarakiRegionSetting;
};

export const AreaSelect: React.FC<Props> = ({
  areaId,
  setAreaId,
  cityDomain,
  customerSetting
}) => {
  const theme = useTheme();
  const areas = useMemo(() => {
    if (cityDomain === null) {
      return [];
    }
    const city = customerSetting.cities[cityDomain];
    return customerSetting.areas.filter((area) => area.cityId === city.cityId);
  }, [customerSetting.areas, cityDomain, customerSetting.cities]);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <InputLabel
          id="searchbox-area-label"
          htmlFor="searchbox-area"
          sx={theme.typography.body2}
        >
          エリアで絞り込む
        </InputLabel>
        {cityDomain && (
          <Link
            href={relativePath(
              `/${cityDomain}/about-area/`,
              IBARAKI_REGION_ROUTE
            )}
            sx={theme.typography.body2}
          >
            エリアについて
          </Link>
        )}
      </Box>
      <Select
        labelId="searchbox-area-label"
        fullWidth
        size="small"
        inputProps={{
          id: 'searchbox-area',
          sx: {
            color: areaId === null ? theme.palette.text.disabled : undefined
          }
        }}
        value={areaId === null ? 'null' : areaId}
        onChange={(e) => {
          if (e.target.value === 'null') {
            setAreaId(null);
          } else {
            setAreaId(e.target.value);
          }
        }}
        disabled={!cityDomain}
      >
        <MenuItem value="null">エリアを選択</MenuItem>
        {areas.map(({ areaId, areaName }) => (
          <MenuItem key={areaId} value={areaId.toString()}>
            {areaName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
